<su-slot-dialog-title [title]="title"></su-slot-dialog-title>

<su-slot-dialog-content>
  <div card-content class="dialog">
    <su-headline h="h3">{{ message }}</su-headline>
    <formly-form
      [fields]="formFields"
      [form]="form"
      [model]="formModel">
    </formly-form>
  </div>
</su-slot-dialog-content>


